export default {
  async fetch({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setTelemetryEntries");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setTelemetryEntries({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    const { agencyId } = rootGetters["application/getSelectedAgency"] || {};

    try {
      const data = agencyId
        ? await this.$services.telemetry.fetchByAgency(agencyId, {
            size,
            page,
            sortBy,
            orderBy,
            filter,
          })
        : await this.$services.telemetry.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_TELEMETRY_ENTRIES", data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async prepareCsv({ dispatch, commit, rootGetters }, params) {
    const { agencyId } = rootGetters["application/getSelectedAgency"] || {};
    try {
      await this.$services.telemetry.preparecsv(agencyId, params);
      await dispatch("application/setDownloads", {}, { root: true });
      commit("application/SET_IS_WAITING_FOR_DOWNLOADS", true, { root: true });
      this.$feedback.ok("generic.download.ok");
    } catch {
      this.$feedback.error("generic.download.error");
    }
  },
};
